import React, { ReactNode } from "react";
import Grid, { GridSize } from "@material-ui/core/Grid";
import { makeStyles, createStyles } from "@material-ui/core/styles";

type Props = {
  items?: ReactNode[];
  submitButton?: ReactNode;
  columns?: boolean | GridSize;
};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      backgroundColor: "white",
      borderRadius: "4px",
      padding: "1.5rem 0.5rem",
      margin: 0,
      width: "100%",
      display: "flex",
      alignItems: "flex-end",
    },
  })
);

export const Form: React.FC<Props> = ({
  items = [],
  columns = 4,
  submitButton,
}) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2} className={classes.root}>
      {items.map((item, i) => (
        <Grid item xs={12} sm={columns} key={i}>
          {item}
        </Grid>
      ))}
      <Grid item xs={12}>
        {submitButton}
      </Grid>
    </Grid>
  );
};
